import type { Step } from '@bugbug/core/types/steps';

export type TemporaryStep = Step & { isTemporary: true; atIndex: number };

export const isTemporaryStep = (step: Step | TemporaryStep): step is TemporaryStep =>
  (step as TemporaryStep).isTemporary === true;
